import { Button, Col, Divider, Form, Input, Row } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import packageJson from "../../../package.json";
import sentEmail from "../../assets/images/icon/sentEmail.svg";
import LOGO from "../../assets/images/ieat_logo_login.png";
import FailModal from "../../components/modal/failModal";
import { SUCCESS_CODE } from "../../lib/const";
import { routes } from "../../routes";
import { forgotPassword } from "../../services/authService";

import "./styles.css";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [submittable, setSubmittable] = useState(false);
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);

  const [errStatus, setErrStatus] = useState({
    status: false,
    msg: "",
  });
  const [sendSuccess, setSendSuccess] = useState({
    status: false,
    msg: "",
  });

  const [failModal, setFailModal] = useState(false);

  useEffect(() => {
    if (values?.email) {
      setSubmittable(true);
      setErrStatus({
        status: false,
        msg: "",
      });
    }
  }, [values, form, submittable]);

  const onFinish = async (values) => {
    const request = {
      email: values.email,
    };
    const res = await forgotPassword(request);
    if (res.data.code === SUCCESS_CODE) {
      setSendSuccess({
        status: true,
      });
    } else {
      setFailModal(true);
      if (res.data.code === "ERR-9999") {
        setErrStatus({
          status: true,
          msg: "เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์", // internal server err
        });
      } else if (res.data.code === "ERR-0012") {
        setErrStatus({
          status: true,
          msg: "ขออภัยไม่พบอีเมลในระบบ",
        });
      }
    }
  };

  return (
    <div className="page">
      <div className="sign_in">
        <div className="bg_signin" />
        <Row gutter={[24, 16]} style={{ height: "100%" }}>
          <Col
            span={10}
            align="center"
            style={{
              margin: "auto",
            }}
          >
            <div style={{ marginLeft: 100 }}>
              <Row gutter={[16]}>
                <Col span={24}>
                  <img
                    src={LOGO}
                    // width={120}
                    height={120}
                    alt={"I-EA-T LOGO"}
                    align="left"
                  />
                </Col>
                <Col span={24} align="left" style={{ marginBottom: 250 }}>
                  <h1 style={{ margin: "0 0 5px 0" }}>
                    การนิคมอุตสาหกรรมแห่งประเทศไทย
                  </h1>
                  <h3 style={{ fontWeight: 400, margin: "0 0 5px 0" }}>
                    Industrial Estate Authority of Thailand
                  </h3>
                </Col>
              </Row>
            </div>
          </Col>
          <Col
            span={14}
            align="center"
            style={{
              margin: "auto",
            }}
          >
            {!sendSuccess.status ? (
              <Form
                form={form}
                className="signin_form"
                name="basic"
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                <p
                  style={{
                    textAlign: "left",
                    fontSize: 27,
                    fontWeight: 600,
                    margin: 0,
                  }}
                >
                  ลืมรหัสผ่าน
                </p>
                <p
                  style={{
                    textAlign: "left",
                    fontSize: 14,
                    fontWeight: 500,
                    margin: 0,
                  }}
                >
                  รีเซ็ตรหัสผ่านด้วยอีเมลที่ใช้งาน
                </p>

                <Divider dashed />

                {errStatus.status && (
                  <p
                    style={{
                      color: "#F04438",
                      textAlign: "center",
                      fontSize: 16,
                      margin: " 20px 0px",
                    }}
                  >
                    {errStatus.msg}
                  </p>
                )}

                <Form.Item
                  label="อีเมล"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "โปรดระบุ",
                    },
                    {
                      type: "email",
                      message: "รูปแบบอีเมลไม่ถูกต้อง",
                    },
                  ]}
                  style={{ marginBottom: 20, textAlign: "left" }}
                >
                  <Input placeholder="โปรดระบุอีเมลที่ทำการสมัคร" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%", marginTop: 20 }}
                    disabled={!submittable}
                  >
                    รีเซ็ตรหัสผ่าน
                  </Button>
                </Form.Item>

                <Row style={{ marginTop: 25 }}>
                  <Col span={24} align="center" style={{ marginBottom: 15 }}>
                    <Link
                      to={routes.signin}
                      style={{ textDecoration: "underline" }}
                    >
                      เข้าสู่ระบบอีกครั้ง
                    </Link>
                  </Col>

                  <Col span={24} align="center" style={{ marginTop: 15 }}>
                    <span>©</span>{" "}
                    <span style={{ color: "#A4A2A2" }}>
                      2023 All Right Reserved
                    </span>
                    <p style={{ color: "#A4A2A2", fontSize: 12 }}>
                      Website Version {packageJson.version}
                    </p>
                  </Col>
                </Row>
              </Form>
            ) : (
              <Row className="signin_form">
                <Col span={24}>
                  <img
                    src={sentEmail}
                    width={65}
                    height={65}
                    alt="forgot email"
                  />

                  <p
                    style={{
                      textAlign: "center",
                      fontSize: 27,
                      fontWeight: 600,
                      margin: 0,
                    }}
                  >
                    ตรวจสอบอีเมลของคุณ
                  </p>
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: 14,
                      fontWeight: 500,
                      margin: 0,
                      color: "#667085",
                    }}
                  >
                    เราได้ส่งคำแนะนำและรหัสผ่านใหม่ไปยังอีเมล ของคุณแล้ว
                  </p>

                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%", marginTop: 20 }}
                    onClick={() => {
                      navigate(routes.signin, { replace: true });
                    }}
                  >
                    เข้าสู่ระบบอีกครั้ง
                  </Button>

                  <Divider dashed />

                  <p style={{ color: "#667085" }}>
                    คุณไม่ได้รับลิงก์?{" "}
                    <span
                      style={{
                        color: "#2E90FA",
                        cursor: "pointer",
                        fontWeight: 600,
                      }}
                      onClick={() =>
                        setSendSuccess({
                          status: false,
                        })
                      }
                    >
                      ส่งอีกครั้ง
                    </span>
                  </p>
                </Col>
              </Row>
            )}
          </Col>
        </Row>

        <FailModal open={failModal} setOpen={setFailModal} />
      </div>
    </div>
  );
};

export default ForgotPassword;
